module.exports = __webpack_public_path__ + "img/payment-failure-circle.b821f7fd.svg";